var map = {
  "./en.yaml": [
    "1075",
    [
      "src_locales_en_yaml"
    ]
  ],
  "./nl.yaml": [
    "85406",
    [
      "src_locales_nl_yaml"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 90452;
module.exports = __rspack_async_context;
